import { Immutable } from "immer";

import type { SpacingSubBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

/**
 * Reproduce the exact GLOBAL class strings emitted by the Django partial
 * ``tsicommon_cms/blocks/sub-blocks/spacing-sub-block.html``:
 *
 *   {% if spacing.top_spacing %}top-spacing top-{{ spacing.top_spacing }}{% endif %}
 *   {% if spacing.top_inner_spacing %}top-inner-spacing top-inner-{{ spacing.top_inner_spacing }}{% endif %}
 *   {% if spacing.bottom_spacing %}bottom-spacing bottom-{{ spacing.bottom_spacing }}{% endif %}
 *   {% if spacing.bottom_inner_spacing %}bottom-inner-spacing bottom-inner-{{ spacing.bottom_inner_spacing }}{% endif %}
 *
 * These are GLOBAL classes (styled by the sites' global block SCSS), NOT the
 * CSS-module ``getSpacingClasses`` in ``tsi-common-react/src/components/_spacing/spacing``,
 * which produces hashed names that the global SCSS does not match. Shared block
 * ports that render the spacing sub-block must use THIS helper so the SSR output
 * is byte-identical to the legacy server render. Mirrors the stearns-local
 * ``sites/tsi-stearns/client/src/blocks/spacing.ts`` helper, hoisted to the lib
 * for reuse by future shared block ports.
 */
export const getGlobalSpacingClasses = (
    spacing: Immutable<SpacingSubBlock> | null | undefined,
): string => {
    if (!spacing) {
        return "";
    }
    return concatClassNames([
        spacing.top_spacing ? `top-spacing top-${spacing.top_spacing}` : "",
        spacing.top_inner_spacing
            ? `top-inner-spacing top-inner-${spacing.top_inner_spacing}`
            : "",
        spacing.bottom_spacing
            ? `bottom-spacing bottom-${spacing.bottom_spacing}`
            : "",
        spacing.bottom_inner_spacing
            ? `bottom-inner-spacing bottom-inner-${spacing.bottom_inner_spacing}`
            : "",
    ]);
};
